export default "__VITE_ASSET__DUWMmSQD__"